import type { loader } from "@remix/root";

/* eslint-disable @typescript-eslint/naming-convention */
interface Props {
  env: ReturnType<typeof loader>["ENV"];
}

/**
 * Client ENV vars, these will be exposed on `window.ENV` as a property.
 *
 * ⚠️ CAREFUL not to expose any server only secrets!
 */
const ClientEnvVars = ({ env }: Props) => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `window.ENV=${JSON.stringify(env)}`,
      }}
      suppressHydrationWarning
    />
  );
};

export { ClientEnvVars };
